export default __webpack_public_path__ + "static/media/les_yeux_coulent.cf97c379.jpg";